/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API Exporter
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * List of transformers
 * @export
 * @enum {string}
 */

export const TransformersEnum = {
    GptDescription: 'GPT_DESCRIPTION',
    GptTitle: 'GPT_TITLE',
    RemoveHieroglyphs: 'REMOVE_HIEROGLYPHS',
    RemoveHieroglyphsInSizeGrid: 'REMOVE_HIEROGLYPHS_IN_SIZE_GRID',
    RemoveHieroglyphsInVendorCode: 'REMOVE_HIEROGLYPHS_IN_VENDOR_CODE',
    TranslateDescription: 'TRANSLATE_DESCRIPTION',
    TranslateTitle: 'TRANSLATE_TITLE',
    TranslateParameters: 'TRANSLATE_PARAMETERS',
    TranslateProperties: 'TRANSLATE_PROPERTIES',
    TranslateSizes: 'TRANSLATE_SIZES',
    MappingParameters: 'MAPPING_PARAMETERS',
    MappingCategories: 'MAPPING_CATEGORIES',
    SquareImages: 'SQUARE_IMAGES',
    NormalizeSaleDate: 'NORMALIZE_SALE_DATE',
    RuGenders: 'RU_GENDERS',
    RoundingPrice: 'ROUNDING_PRICE',
    MappingVendorCode: 'MAPPING_VENDOR_CODE',
    ImageTransform: 'IMAGE_TRANSFORM'
} as const;

export type TransformersEnum = typeof TransformersEnum[keyof typeof TransformersEnum];



